/**
 * @generated SignedSource<<67802c6a77c19df2e12cc4aafc083030>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionInfo_item$data = {
  readonly isSold: boolean | null;
  readonly isUnavailable: boolean | null;
  readonly lastTransaction?: {
    readonly checkoutDate: string | null;
    readonly isCanceled: boolean | null;
    readonly isSecondChanceOfferActive: boolean | null;
    readonly isWinningAuctionOrder: boolean | null;
    readonly mostRecentOffer: {
      readonly id: string;
      readonly isExpired: boolean | null;
      readonly serviceId: string | null;
    } | null;
  } | null;
  readonly relevantAuctionLot: {
    readonly endDate: string | null;
    readonly serviceId: string | null;
  } | null;
  readonly relevantAuctionSolution: {
    readonly highestBidderId: string | null;
    readonly reserveMet: boolean | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBid_item" | "PdpSharedAuctionActionBinAndBid_item" | "PdpSharedAuctionActionCompletePurchase_item" | "PdpSharedAuctionClosed_item" | "PdpSharedAuctionPreview_item" | "PdpSharedAuctionSecondChanceOffer_item" | "PdpSharedAuctionSubscription_item" | "PdpSharedOriginalPriceWithReserveStatusVariant_item" | "PriceDisplay_item" | "bidModalTrackingHelpers_item" | "useAuctionPricing_item" | "useAuctionSecondChanceInfo_item" | "useAuctionState_item" | "useOriginalListPrice_item">;
  readonly " $fragmentType": "PdpSharedAuctionInfo_item";
};
export type PdpSharedAuctionInfo_item$key = {
  readonly " $data"?: PdpSharedAuctionInfo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionInfo_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionInfo_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnavailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionLot(page:\"pdp\")"
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reserveMet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "highestBidderId",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionSolution(page:\"pdp\")"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "concreteType": "Transaction",
          "kind": "LinkedField",
          "name": "lastTransaction",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCanceled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "checkoutDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isWinningAuctionOrder",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSecondChanceOfferActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "mostRecentOffer",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isExpired",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionSecondChanceInfo_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionSubscription_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionState_item"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBinAndBid_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBid_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionClosed_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionCompletePurchase_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionPreview_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionSecondChanceOffer_item"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "bidModalTrackingHelpers_item",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "AuctionSolution",
          "kind": "LinkedField",
          "name": "relevantAuctionSolution",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "minNextBidAmount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "relevantAuctionSolution(page:\"pdp\")"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "level",
              "value": 1
            }
          ],
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "getCategoriesByLevel",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": "getCategoriesByLevel(level:1)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vertical",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "useOriginalListPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedOriginalPriceWithReserveStatusVariant_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "01f2e7d9a8a25e998c8a431c009441dd";

export default node;
